import React, { Component, PropTypes } from 'react'
import ChipInput from 'material-ui-chip-input'
import { without, find } from 'lodash'

import api from '../../api'

class MultiOptionSelector extends Component<any, any> {
  state = {
    field: null
  }

  componentWillMount () {
    api.get('v2/settings')
      .then(res => res.json())
      .then(settings => {
        this.setState({ field: settings[this.props.settingKey] })
      })
  }

  handleChipInputAdd = chip => {
    const newValue = (this.props.value || []).concat(chip.value)
    this.props.onChange(null, newValue)
  }

  handleChipInputDelete = value => {
    const newValue = without(this.props.value, value)
    this.props.onChange(null, newValue)
  }

  render () {
    const { field } = this.state

    if (field === null) {
      return <div />
    }

    const values = (this.props.value || []).map(value => {
      const existing = find(field, { value })
      return existing || { name: value, value }
    })

    return (
      <div>
        <ChipInput
          floatingLabelText={this.props.label}
          onRequestAdd={this.handleChipInputAdd}
          onRequestDelete={this.handleChipInputDelete}
          dataSource={field}
          dataSourceConfig={{ text: 'name', value: 'value' }}
          value={values}
          errorText={this.props.errorText}
          fullWidth
        />
      </div>
    )
  }
}

// @ts-ignore
MultiOptionSelector.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string
}

// @ts-ignore
MultiOptionSelector.defaultProps = {
  value: [],
  errorText: null
}

export default MultiOptionSelector
